import React, { useCallback, useEffect, useRef, useState } from 'react';
import { DateTimeFormatter } from 'brock-date-time';
import {
    Button,
    HorizontalFlex,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    PadContainer,
} from 'smartsuite-ui';

function PasswordModal({ closeModal, submitPassword }) {
    const [password, setPassword] = useState('');

    const inputRef = useRef(null);

    const onSubmit = useCallback(() => {
        if (!password) {
            return;
        }

        closeModal();

        const testPassword = DateTimeFormatter.date(new Date());

        if (password === testPassword) {
            submitPassword(password);
        }
    }, [closeModal, password, submitPassword]);

    useEffect(() => {
        function handleKeyDown(event) {
            if (event.keyCode === 13) {
                onSubmit();
            }
        }

        document.addEventListener('keydown', handleKeyDown);

        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [onSubmit]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <Modal onOverlayClick={() => {}}>
            <ModalHeader onDismiss={closeModal}>Password Required</ModalHeader>
            <ModalBody>
                <PadContainer cssClassModifiers={['pad-medium']}>
                    <span>Please enter the password</span>
                    <Input
                        type="password"
                        onChange={(event) => setPassword(event.target.value)}
                        value={password}
                        reference={inputRef}
                    />
                </PadContainer>
            </ModalBody>
            <ModalFooter>
                <HorizontalFlex cssClassModifiers={['justify-flex-end']}>
                    <Button disabled={!password} onClick={onSubmit}>
                        Submit
                    </Button>
                </HorizontalFlex>
            </ModalFooter>
        </Modal>
    );
}
export default PasswordModal;
